import { render, staticRenderFns } from "./resultado-llamada.vue?vue&type=template&id=0c1e79eb&scoped=true"
import script from "./resultado-llamada.vue?vue&type=script&lang=js"
export * from "./resultado-llamada.vue?vue&type=script&lang=js"
import style0 from "./resultado-llamada.vue?vue&type=style&index=0&id=0c1e79eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1e79eb",
  null
  
)

export default component.exports